import type { Asset } from '#/graphql/types';
import type { ColumnProps } from '#/common/components/DataGrid';
import { RadioButton } from '../../utils/MatchingColumnsStyles';

export interface MatchAssetColumnsOptions {
  getSelectedAssetId?: () => string | null;
  onSelectAssetId?: (id: string) => void;
  isDefaultSelectedAsset?: (asset: Asset) => boolean;
}

export const createMatchAssetColumns = (
  options: MatchAssetColumnsOptions = {},
): ColumnProps<Asset>[] => [
  {
    dataField: '__radio_selection' as any,
    caption: '',
    width: 54,
    visible: true,
    fixed: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
    alignment: 'center',
    cellRender: (e: any) => {
      const rowAsset = e.data as Asset;
      const rowId = rowAsset?.id;

      if (!rowId) {
        return null;
      }

      const selectedAssetId = options.getSelectedAssetId?.();
      const isChecked = selectedAssetId
        ? selectedAssetId === rowId
        : !!options.isDefaultSelectedAsset?.(rowAsset);

      return (
        <RadioButton
          type="button"
          aria-label="Select asset"
          aria-pressed={isChecked}
          $checked={isChecked}
          onClick={(event) => {
            event.stopPropagation();
            options.onSelectAssetId?.(rowId);
          }}
        />
      );
    },
  },
  {
    dataField: 'assetTag',
    caption: 'Asset Tag',
    dataType: 'string',
    visible: true,
  },
  {
    dataField: 'serialNumber',
    caption: 'Serial Number',
    dataType: 'string',
    visible: true,
  },
  {
    dataField: 'manufacturer.name',
    caption: 'Manufacturer',
    dataType: 'string',
    visible: true,
  },
  {
    dataField: 'model.name',
    caption: 'Model',
    dataType: 'string',
    visible: true,
  },
  {
    dataField: 'assetType.name',
    caption: 'Type',
    dataType: 'string',
    visible: true,
  },
  {
    dataField: 'location.id',
    caption: 'Location',
    dataType: 'string',
    visible: true,
    filterField: 'location.name',
    cellRender: (e) => e.data?.location?.name || '',
  },
];

const matchAssetColumns = createMatchAssetColumns();

export default matchAssetColumns;
